// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1017cd3c","239":"750e1147","453":"88219b57","455":"0cf02493"}[chunkId] + ".chunk.js";
};